import { SpinResponse } from '@cgs/data-access';
import { Container } from '@cgs/wge';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from './base_game_state';
import { GAME_DATA_SERVICE_TOKEN, GameDataService } from '../../../services/game-data.service';

export abstract class RequestState<
  TResponse extends SpinResponse,
> extends BaseGameState<TResponse> {
  public skipNetworkRequest: boolean = false;
  protected readonly gameDataService: GameDataService;

  constructor(container: Container, responseHolder: ResponseHolder<TResponse>, id: string) {
    super(responseHolder, id);

    this.gameDataService = container.resolve<GameDataService>(GAME_DATA_SERVICE_TOKEN);
  }

  protected abstract doRequest(): Promise<TResponse>;

  public override onEnterImpl(): void {
    super.onEnterImpl();

    if (this.skipNetworkRequest) {
      return;
    }

    void this.doRequest().then((s) => this.onResponse(s));
  }

  public override onLeaveImpl(): void {
    this.skipNetworkRequest = false;
    super.onLeaveImpl();
  }

  private onResponse(response: TResponse): void {
    this.responseHolder.preResponse = this.responseHolder.curResponse;
    this.responseHolder.curServerResponse = response;
  }
}
